module.exports = __webpack_public_path__ + "img/Logo Dashboard.1b433e21.png";